import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  width: string;
  height: string;
  text: string;
  onClick: () => void;
  sx?: any;
}
// TODO 버튼 어떻게 할지?
export const OutlinedGrayButton: React.FC<Props> = ({
  width,
  height,
  text,
  onClick,
  sx,
}) => {
  return (
    <OutlinedButton style={sx} width={width} height={height} onClick={onClick}>
      {text}
    </OutlinedButton>
  );
};

interface OutlinedButtonProps {
  width: string;
  height: string;
}

const OutlinedButton = styled.button<OutlinedButtonProps>`
  width: ${(props) => props.width}};
  height: ${(props) => props.height}};
  background: ${theme.palette.primitives.white};
  border: 1px solid ${theme.palette.primitives.gray100};
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: ${theme.palette.primitives.gray600};
  cursor: pointer;
`;
